
import HotelApi from '@/api/hotel-api'
import { SUPPLEMENT_UNIT_TYPE, SUPPLEMENT_PRICE_TYPE, TRANSFER_TYPE, COMPANY_TYPE, STATUS, VUEX_EVENT } from '@/configs/constant'
import factory from '@/factories/local-storage-factory'

export const getHotelInfo = async (hotelId) => {
  const defaultInfo = {
    emailList: [''],
    phoneList: [''],
    faxList: ['']
  }

  const defaultEmailConfiguration = {
    ccEmailList: [''],
    bccEmailList: ['']
  }

  const defaultHotel = {
    code: '',
    name: '',
    isEnable: STATUS.ENABLE,
    information: { },
    emailConfiguration: { },
    remark: '',
    logoUrl: '',
    address: '',
    senderName: '',
    replyEmail: ''
  }

  const hotel = await HotelApi.info(hotelId)

  hotel.information = Object.assign({}, defaultInfo, hotel.information)
  hotel.emailConfiguration = Object.assign({}, defaultEmailConfiguration, hotel.emailConfiguration)
  const hotelData = Object.assign({}, defaultHotel, hotel)

  return hotelData
}

export const getHotelIndexRoute = async (companyData, store) => {
  let routerName = 'HotelList'
  const hotelList = await HotelApi.list()

  if (companyData.companyType === COMPANY_TYPE.STANDALONE) {
    const hotel = hotelList[0]
    store.dispatch(VUEX_EVENT.GENERAL.SET_ACTIVE_HOTEL_ID, hotel.id)
    store.dispatch(VUEX_EVENT.GENERAL.SET_HOTEL_LIST, hotelList)

    routerName = 'HotelInfo'

    factory.setHotelDetail({
      hotelId: hotel.id,
      hotelList: hotelList,
      companyId: companyData.id
    })
    return routerName
  }

  factory.setHotelDetail({
    hotelList: hotelList,
    companyId: companyData.id
  })
  store.dispatch(VUEX_EVENT.GENERAL.SET_HOTEL_LIST, hotelList)
  store.dispatch(VUEX_EVENT.GENERAL.SET_ACTIVE_COMPANY_ID, companyData.id)

  return routerName
}

export const supplementUnitTypeList = [{
  id: SUPPLEMENT_UNIT_TYPE.PER_PERSON,
  titleKey: 'UNIT_TYPE.PER_PERSON'
}, {
  id: SUPPLEMENT_UNIT_TYPE.PER_ROOM,
  titleKey: 'UNIT_TYPE.PER_ROOM'
}, {
  id: SUPPLEMENT_UNIT_TYPE.PER_BOOKING,
  titleKey: 'UNIT_TYPE.PER_BOOKING'
}, {
  id: SUPPLEMENT_UNIT_TYPE.DISCOUNT,
  titleKey: 'UNIT_TYPE.DISCOUNT'
}]

export const supplementPriceTypeList = [{
  id: SUPPLEMENT_PRICE_TYPE.NET,
  titleKey: 'PRICE_TYPE.NET'
}, {
  id: SUPPLEMENT_PRICE_TYPE.PERCENT,
  titleKey: 'PRICE_TYPE.PERCENT'
}]

export const getUnitTypeTitleKey = (unitTypeId) => {
  const unitType = supplementUnitTypeList.find(item => item.id === unitTypeId)

  return (unitType === undefined) ? 'UNIT_TYPE.NOT_AVAILABLE' : unitType.titleKey
}

export const getPriceTypeTitleKey = (priceTypeId) => {
  const priceType = supplementPriceTypeList.find(item => item.id === priceTypeId)

  return (priceType === undefined) ? 'PRICE_TYPE.NOT_AVAILABLE' : priceType.titleKey
}

export const transferTypeList = [{
  id: TRANSFER_TYPE.PER_CAR,
  title: 'Per Car'
}, {
  id: TRANSFER_TYPE.PER_PERSON,
  title: 'Per Person'
}]
